import { ShopsApiAdapter } from '../adapters/ShopsApiAdapter';
import { Filters, ShopsModel } from '../models/Shops';

export interface Page {
  shops: ShopsModel[];
  nextPage?: number;
  hasMore: boolean;
  total: number;
}

export class Service {
  constructor(private apiAdapter: ShopsApiAdapter) {}

  async getAllMovements(filters: Filters = {}): Promise<ShopsModel[]> {
    return this.apiAdapter.getAll();
  }

  async getPaginatedMovements(filters: Filters = {}): Promise<Page> {
    const { searchTerm, limit } = filters;

    // 🧠 Validaciones opcionales
    if (limit && limit > 100) {
      throw new Error('El límite no puede ser mayor a 100');
    }

    if (searchTerm && searchTerm.length < 2) {
      throw new Error(
        'El término de búsqueda debe tener al menos 2 caracteres'
      );
    }

    return this.apiAdapter.getShopsPaginated(filters);
  }

  async getPaginated(filters: Filters = {}): Promise<Page> {
    const { searchTerm, limit } = filters;

    if (limit && limit > 100) {
      throw new Error('El límite no puede ser mayor a 100');
    }

    if (searchTerm && searchTerm.length < 2) {
      throw new Error(
        'El término de búsqueda debe tener al menos 2 caracteres'
      );
    }

    return this.apiAdapter.getShopsPaginated(filters);
  }
}
